<template>
    <div>
        <v-subheader class="mb-4" v-if="label || textHelper">
            {{ label }}
            <emc-info-help 
                v-if="textHelper"
                icon-color="indigo" 
                title="Informações" 
                :text="textHelper" 
                />
        </v-subheader>
        <v-slider
            v-model="size"
            :max="max"
            :min="min"
            :thumb-size="24"
            :thumb-label="thumbLabel"
            :ticks="ticks"
            :disabled="disabled"
            :step="step"
            hide-details
            append-icon="mdi-plus-circle-outline"
            prepend-icon="mdi-minus-circle-outline"
            @click:append="sizeIn"
            @click:prepend="sizeOut"
        >

        </v-slider>
    </div>
</template>

<script setup>

import { defineProps, defineEmits, computed, watch } from 'vue'

const props = defineProps({
    value: { type: Number, default: 1 },
    label: { type: String, required: false },
    textHelper: { type: String, required: false },
    ticks: { type: Boolean, default: true },
    thumbLabel: { type: [Boolean, String], default: "always" },
    disabled: { type: Boolean, required: false },
    min: { type: Number, default: 1 },
    max: { type: Number, default: 10 },
    step: { type: Number, default: 1 },
})

const emit = defineEmits(['input'])

const size = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

function sizeIn() {

    if (size.value >= props.max) return

    size.value = size.value + props.step
}

function sizeOut() {

    if (size.value <= props.min) return

    size.value = size.value - props.step
}

watch(size, (value) => {
    emit('input', value)
})

watch(() => props.value, (value) => {
    size.value = value
})

</script>